import { render, staticRenderFns } from "./PoiSubTrail.vue?vue&type=template&id=63a790b2"
import script from "./PoiSubTrail.js?vue&type=script&lang=js&external"
export * from "./PoiSubTrail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports